// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"661":"929bb1d1","875":"68b43a7e"}[chunkId] + ".chunk.css";
};